import axiosClient from "..";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class MyBetsService {
  static getMyBets(payload) {
    return axiosClient
      .get("/sb/betSlipsList", {
        params: {
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }

  static betList(payload) {
    return axiosClient
      .get("/sb/betList", {
        params: {
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
  static cashoutAmount(payload) {
    return axiosClient
      .get("/sb/getCashoutAmount", {
        params: {
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }

  static cashOut(payload) {
    return axiosClient
      .post("/sb/cashOut", {
        ...payload
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }

  static sportStatistics(params) {
    return axiosClient
      .get("/sb/sportStatics", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
